import { useCallback, useContext, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AuthContext from "@/contexts/AuthContext";

//Hooks
import { useFormHandler } from "@/core/hooks/useFormHandler";

//Services
import { AuthService } from "@/core/http/services/AuthService";
import { dataValidateCreateUser } from "../utils/validator";
import { formatMobilePhoneWithDDD } from "../utils/phone";

const useRegister = () => {
  const navigate = useNavigate();
  const { inviteToken } = useParams();
  const { signInWithToken } = useContext(AuthContext);

  const { handleChange, formData, setField, removeField } = useFormHandler();
  const validationErrorIdRef = useRef(0);
  const [validationError, setValidationError] = useState(null);
  const [requestError, setRequestError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [actionLoading, setActionLoading] = useState(false);

  const raiseValidationError = (error, field) => {
    validationErrorIdRef.current += 1;
    setValidationError({
      id: validationErrorIdRef.current,
      error,
      field,
    });
  };

  const handleCreateUser = async (payload) => {
    setValidationError(null);
    setRequestError(null);
    setSuccessMessage(null);
    setActionLoading(true);

    const { validData, error, field } = dataValidateCreateUser(payload);

    if (!validData) {
      raiseValidationError(error, field);
      setActionLoading(false);
      return;
    }

    const normalizedPayload = {
      name: payload.name?.trim(),
      email: payload.email?.trim(),
      phone: formatMobilePhoneWithDDD(payload.phone),
      password: payload.password,
      birthDate: payload.birthday,
    };

    try {
      const { status, message, data } = await AuthService.register(normalizedPayload, {
        inviteToken,
      });

      if (status === 201 || status === 200) {
        if (!data?.token || !data?.user || !data?.player) {
          setRequestError("Conta criada, mas a resposta de autenticacao veio incompleta.");
          return;
        }

        await signInWithToken(data);

        setSuccessMessage("Conta criada com sucesso! Entrando na plataforma...");
        navigate("/user/redirect");
      } else {
        setRequestError(
          message || "Erro ao criar conta. Verifique os dados informados.",
        );
      }
    } catch (err) {
      setRequestError(err?.message || "Erro inesperado ao criar conta.");
    } finally {
      setActionLoading(false);
    }
  };

  const initialize = useCallback(async () => {
    return;
  }, []);

  return {
    handleCreateUser,
    validationError,
    requestError,
    successMessage,
    actionLoading,
    initialize,

    setField,
    removeField,
    handleChange,
    formData,
  };
};

export default useRegister;
